<script lang="ts">
  type headerType = {
    label: string
    key: string
    blankText?: string
    format?: Function
    sorting?: boolean
  }
  interface Props {
    fields: headerType[]
    sortField?: string
    sortDirection?: string
    data: any[]
    showNum?: boolean
    noValue?: string
    hasActions?: boolean
    onsort?: (sortV: any) => void
  }

  let {
    fields,
    sortField = $bindable(),
    sortDirection = $bindable(),
    data = [],
    showNum = false,
    noValue = "",
    hasActions = true, // To show hide actions column
    onsort
  }: Props = $props()

  const chevron = `<svg class="svelte-fa svelte-xj8byo" style="height:1em;font-size:12;vertical-align:-.125em;transform-origin:center;overflow:visible" viewBox="0 0 448 512" aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg"><g transform="translate(224 256)" transform-origin="112 0"><g transform="translate(0,0) scale(1,1)"><path d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z" fill="currentColor" transform="translate(-224 -256)"></path></g></g></svg>`
</script>

<table class="table-auto w-full data-table">
  <slot name="head">
    <thead class="bg-gray-50 sticky top-0 z-10 border-b border-gray-200">
      <tr>
        <th
          class="px-2 py-3 text-left text-sm font-semibold text-gray-900"
          class:hidden={!showNum}>No.</th
        >
        {#each fields as field}
          <th
            class="whitespace-nowrap px-2 py-3 text-left text-sm font-semibold text-gray-900 {field.sorting
              ? 'hover:text-blue-600 hover:underline'
              : ''}"
          >
            <button
              class="flex gap-2 items-center"
              class:cursor-pointer={field.sorting}
              onclick={() => {
                if (field.sorting) onsort({ key: field.key, sortDirection })
              }}
            >
              {field.label}
              {#if sortField === field.key}
                <span
                  style="transform:rotate({sortDirection === 'asc'
                    ? '180deg'
                    : '0deg'})"
                  >{@html chevron}
                </span>
              {/if}
            </button>
          </th>
        {/each}
        {#if hasActions}
          <th></th>
        {/if}
      </tr>
    </thead>
  </slot>
  <tbody class="divide-y divide-gray-200 bg-white">
    <slot>
      {#each data as dat, idx}
        <tr class:bg-slate-600={dat._selected}>
          <td
            class="py-3 px-2 text-sm font-medium text-gray-900"
            class:hidden={!showNum}>{idx + 1}</td
          >
          {#each fields as fld}
            <td class="py-3 px-2 text-sm font-medium text-gray-900">
              {#if dat[fld.key] || dat[fld.key] === false}
                {@const currentVal = fld.format
                  ? fld.format(dat)
                  : dat[fld.key]}
                {@html currentVal}
              {:else}
                {@const blk = fld.blankText || noValue}
                {@html dat[fld.key] || blk}
              {/if}
            </td>
          {/each}
          <td>
            <slot name="actions" item={dat} />
          </td>
        </tr>
      {:else}
        <tr>
          <td
            colspan={`${fields.length + 1}`}
            class=" text-lg font-medium text-gray-900 text-center py-2"
          >
            No Results Found
          </td>
        </tr>
      {/each}
    </slot>
  </tbody>
</table>
